import { SaleConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case SaleConstant.SET_SALE:
      return { ...state, detail: payload };
    case SaleConstant.SET_SALES:
      return { ...state, list: payload };
    default:
      return state;
  }
};
